import { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Input from '../Input';
import CheckBoxUnChecked from '../icons/CheckBoxUnChecked';
import CheckBoxChecked from '../icons/CheckBoxChecked';

import styles from './Checkbox.module.scss';

const cx = classNames.bind(styles);

const Checkbox = ({
  callback = () => {},
  checked = false,
  dataAttributes = {},
  id,
  name,
  required = false,
  size = 'normal'
}) => {
  const [isChecked, setIsChecked] = useState(checked);

  const handleCheckbox = () => {
    const newChecked = !isChecked;
    setIsChecked(newChecked);
    callback(newChecked);
  };

  const checkboxClassName = cx(styles.checkbox, {
    [styles['checkbox-size-normal']]: size === 'normal',
    [styles['checkbox-size-small']]: size === 'small'
  });

  return (
    <div className={styles.wrapper}>
      <Input
        checked={isChecked}
        className={checkboxClassName}
        id={id}
        name={name}
        onChange={handleCheckbox}
        required={required}
        dataAttributes={dataAttributes}
        type="checkbox"
      />
      {isChecked ? (
        <CheckBoxChecked size={size} />
      ) : (
        <CheckBoxUnChecked size={size} />
      )}
    </div>
  );
};

Checkbox.propTypes = {
  callback: PropTypes.func,
  checked: PropTypes.bool,
  dataAttributes: PropTypes.object,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'normal'])
};

export default Checkbox;
